// Chrome / Firefox / Safari wording for a failed lazy chunk, plus Vite's own error when a chunk's split CSS is gone
const CHUNK_ERROR =
  /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|is not a valid JavaScript MIME type|Unable to preload CSS/i
const RELOAD_KEY = 'stale-chunk-reload-at'
// long enough that a slow connection cannot fail the same missing chunk again after the window and reload in a loop
const RELOAD_WINDOW_MS = 60_000

/** A deploy replaced the hashed lazy chunks under an open tab: reload once to pick up the new build. */
export function reloadOnStaleChunk(error: unknown): boolean {
  if (!CHUNK_ERROR.test(error instanceof Error ? error.message : String(error))) {
    return false
  }

  // offline the same message means "no network", and a reload would land on the browser's offline page
  if (navigator.onLine === false) {
    return false
  }

  // without storage the reload cannot be limited to once, so a chunk that stays missing would loop
  try {
    if (Date.now() - Number(sessionStorage.getItem(RELOAD_KEY)) < RELOAD_WINDOW_MS) {
      return false
    }
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()))
  } catch {
    return false
  }

  window.location.reload()
  return true
}
